import { useMutation, useQueryClient } from "@tanstack/react-query";
import client from "api/graphql/getClient";
import { graphql } from "gql/gql";
import { DeleteOutgoingWebhookParams } from "gql/graphql";
import { useActiveAccount } from "utils/useActiveAccount";

const deleteOutgoingWebhookDocument = graphql(/* GraphQL */ `
	mutation deleteOutgoingWebhook($params: DeleteOutgoingWebhookParams!) {
		deleteOutgoingWebhook(params: $params) {
			error {
				code
				message
			}
			success
		}
	}
`);

interface Args {
	params: DeleteOutgoingWebhookParams;
	userId?: string;
}

const deleteOutgoingWebhook = ({ userId, params }: Args) =>
	client(userId)
		.request(deleteOutgoingWebhookDocument, { params })
		.then((res) => res.deleteOutgoingWebhook);

const useDeleteOutgoingWebhook = () => {
	const { userId, _id } = useActiveAccount();
	const queryClient = useQueryClient();

	return useMutation(
		(params: DeleteOutgoingWebhookParams) =>
			deleteOutgoingWebhook({ params, userId }),
		{
			onSettled: () => {
				queryClient.invalidateQueries([
					"user",
					userId,
					"account",
					_id,
					"outgoingWebhooks",
				]);
			},
		}
	);
};

export default useDeleteOutgoingWebhook;
